import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css'
import Toggle from 'react-toggle'
import axios from 'axios'
import Constant from '../../Constant'
import CustomFooter from '../../common/TableBottom'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
import Button from '../../common/CustomComponents/Button'
import Select from 'react-select'
import Loader from '../../common/Loader'
import Moment from 'react-moment'
import CheckPermission from '../../common/Permissions/CheckPermission'

class ReviewList extends React.Component {
  state = {
    review_data: [],
    isloading: false,
    isSearching: false,
    keyword: '',
    limit: 10,
    pageNumber: 0,
    totalCount: 0,
    totalPages: 0,
    disabled: false,

    ratingForData: null,
    reviewTypeData: null,
    ratingData: null,
    isPublishedData: null,

    ratingForList: [
      { label: 'Cruise', value: 'CRUISE' },
      { label: 'Chalet', value: 'CHALET' },
      // { label: 'Event', value: 'EVENT' },
      // { label: 'Kashta', value: 'KASHTA' },
      // { label: 'Trip', value: 'TRIP' },
    ],
    reviewTypeList: [
      { label: 'Customer', value: 'CUSTOMER' },
      { label: 'Admin', value: 'ADMIN' },
    ],
    ratingList: [
      { label: '1 Star', value: '1' },
      { label: '2 Stars', value: '2' },
      { label: '3 Stars', value: '3' },
      { label: '4 Stars', value: '4' },
      { label: '5 Stars', value: '5' },
    ],
    isPublishedList: [
      { label: 'Published', value: 'true' },
      { label: 'Unpublished', value: 'false' },
    ],
  }

  debounceTimeout = null

  handlePublishToggle = (reviewId, currentStatus) => {
    if (reviewId) {
      let data = {
        is_published: !currentStatus,
      }

      axios
        .put(Constant.getAPI() + `/admin/toggle-publish-review/${reviewId}`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          this.loadData()
          Swal.fire('Updated!', 'Review publish status has been updated.', 'success')
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  deleteReview = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this review permanently!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.value) {
        axios
          .delete(Constant.getAPI() + `/admin/delete-review/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
          .then(() => {
            Swal.fire({
              title: 'Deleted Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
            this.loadData()
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
      }
    })
  }

  componentDidMount() {
    this.loadData()
  }

  loadData = async () => {
    this.setState({ isSearching: true, review_data: [] })

    const params = {
      keyword: this.state.keyword,
      limit: this.state.limit,
      page: this.state.pageNumber + 1,
    }

    if (this.state.ratingForData?.value) params.rating_for = this.state.ratingForData.value
    if (this.state.reviewTypeData?.value) params.review_type = this.state.reviewTypeData.value
    if (this.state.ratingData?.value) params.rating = this.state.ratingData.value
    if (this.state.isPublishedData?.value) params.is_published = this.state.isPublishedData.value

    await axios
      .get(Constant.getAPI() + `/admin/list-reviews`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: params,
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            review_data: res.data.data.reviews || [],
            totalCount: res.data.data.pagination?.total || 0,
            totalPages: res.data.data.pagination?.totalPages || 0,
            disabled: this.state.pageNumber + 1 >= (res.data.data.pagination?.totalPages || 0),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isSearching: false })
      })
  }

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.loadData()
        }, 500)
      }
    )
  }

  clearSearch = () => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.loadData()
      }
    )
  }

  handleRatingForChange = (event) => {
    this.setState({ ratingForData: event })
  }

  handleReviewTypeChange = (event) => {
    this.setState({ reviewTypeData: event })
  }

  handleRatingChange = (event) => {
    this.setState({ ratingData: event })
  }

  handleIsPublishedChange = (event) => {
    this.setState({ isPublishedData: event })
  }

  handleClearRatingFor = () => {
    this.setState({ ratingForData: null })
  }

  handleClearReviewType = () => {
    this.setState({ reviewTypeData: null })
  }

  handleClearRating = () => {
    this.setState({ ratingData: null })
  }

  handleClearIsPublished = () => {
    this.setState({ isPublishedData: null })
  }

  handleSearch = () => {
    this.setState({ pageNumber: 0 }, () => {
      this.loadData()
    })
  }

  handleClearAll = () => {
    this.setState(
      {
        ratingForData: null,
        reviewTypeData: null,
        ratingData: null,
        isPublishedData: null,
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.loadData()
      }
    )
  }

  renderStars = (rating) => {
    const stars = []
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i
          key={i}
          className={`icofont ${i <= rating ? 'icofont-star' : 'icofont-star'}`}
          style={{ color: i <= rating ? '#FFD700' : '#ccc', fontSize: '16px' }}
        ></i>
      )
    }
    return <div>{stars}</div>
  }

  render() {
    const customSearchRender = (searchText, handleSearch, hideSearch) => {
      return (
        <div className="container">
          <div className="d-flex justify-content-around">
            <i className="f-16 icofont icofont-search m-t-10 m-r-10"></i>
            <input
              type="search"
              className="form-control custom-input-search"
              placeholder="Search reviews"
              value={this.state.keyword}
              name="keyword"
              onChange={this.onSearch}
            />
            <span
              className="pointer m-t-5"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.clearSearch(hideSearch)
              }}
            >
              <i className="f-24 icofont icofont-close m-l-10"></i>
            </span>
          </div>
        </div>
      )
    }

    const columns = [
      {
        name: 'rating_for',
        label: 'Booking Details',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (rating_for, tableMeta) => {
            const reviewData = this.state.review_data[tableMeta.rowIndex]
            const bookingType = reviewData?.booking_type || ''
            const orderNumber = reviewData?.order_number || '----'
            const bookingId = reviewData?.booking_id || ''

            // const badges = {
            //   CRUISE: 'badge-primary',
            //   CHALET: 'badge-success',
            //   EVENT: 'badge-warning',
            //   KASHTA: 'badge-info',
            //   TRIP: 'badge-secondary',
            // }

            let bookingPath = ''
            switch (bookingType) {
              case 'C':
                bookingPath = `/booking-ordering/${bookingId}`
                break
              case 'CH':
                bookingPath = `/chalet-booking-details/${bookingId}`
                break
              case 'E':
                bookingPath = `/new-evt/${bookingId}`
                break
              case 'T':
                bookingPath = `/trip-bookings/details/${bookingId}`
                break
              default:
                break
            }

            return (
              <div style={{ textWrap: 'nowrap' }}>
                {/* <div>
                  <span className={`badge ${badges[rating_for] || 'badge-dark'}`}>{rating_for}</span>
                </div> */}
                {orderNumber && bookingPath && (
                  <div style={{ marginTop: '5px' }}>
                    <span>
                      {' '}
                      <Link to={bookingPath} className="text-primary">
                        {orderNumber}
                      </Link>
                    </span>
                  </div>
                )}
                {orderNumber && !bookingPath && (
                  <div style={{ marginTop: '5px' }}>
                    <span>{orderNumber}</span>
                  </div>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'rating',
        label: 'Rating',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (rating) => {
            return this.renderStars(rating)
          },
        },
      },
      {
        name: 'Comment',
        label: 'Comment',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (comment) => {
            return (
              <div style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {comment || '-'}
              </div>
            )
          },
        },
      },
      {
        name: 'reviewer_name',
        label: 'Reviewer/Customer Name',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (reviewer_name) => {
            return (
              <div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {reviewer_name || '-'}
              </div>
            )
          },
        },
      },
      {
        name: 'review_type',
        label: 'Review Type',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (review_type) => {
            return (
              <span className={`badge ${review_type === 'ADMIN' ? 'badge-danger' : 'badge-info'}`}>
                {review_type}
              </span>
            )
          },
        },
      },
      {
        name: 'is_published',
        label: 'Published',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_published, tableMeta) => {
            const reviewId = this.state.review_data[tableMeta.rowIndex]?.id
            return (
              <Toggle
                checked={is_published}
                onChange={() => this.handlePublishToggle(reviewId, is_published)}
              />
            )
          },
        },
      },
      {
        name: 'createdAt',
        label: 'Created At',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (data) => {
            return data ? (
              <div style={{ textWrap: 'nowrap' }}>
                <Moment format="YYYY-MM-DD hh:mm:ss A">{data}</Moment>
              </div>
            ) : (
              '--'
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div style={{ display: 'flex' }}>
                <CheckPermission permission="edit-admin-review">
                  <Link
                    to={`/admin-review/edit/${id}`}
                    className="m-r-15 text-muted"
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    data-original-title="Edit Review"
                  >
                    <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                  </Link>
                </CheckPermission>
                <CheckPermission permission="delete-admin-review">
                  <span
                    onClick={() => this.deleteReview(id)}
                    className="m-r-15 text-muted"
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    data-original-title="Delete"
                    style={{ cursor: 'pointer' }}
                  >
                    <i className="f-20 icofont icofont-delete-alt text-danger"></i>
                  </span>
                </CheckPermission>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      search: false,
      filter: false,
      count: this.state.totalCount,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      serverSide: true,
      selectableRows: 'none',
      customSearchRender: customSearchRender,
      onSearchClose: () => {
        this.clearSearch()
      },
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => this.loadData()
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            pageNumber: 0,
          },
          () => this.loadData()
        )
      },
      textLabels: {
        body: {
          noMatch: this.state.isSearching ? <Loader open={this.state.isSearching} /> : 'Sorry, No Reviews Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Admin Reviews</h4>
                    </div>
                  </div>
                  <CheckPermission permission="add-admin-review">
                    <Button
                      component={Link}
                      variant="outlined"
                      color="primary"
                      className="f-right ml-1"
                      to="/admin-review/add"
                    >
                      <i className="icofont icofont-plus m-r-5"></i> Add Review
                    </Button>
                  </CheckPermission>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Admin Reviews</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Search</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              id="keyword"
                              className="form-control"
                              value={this.state.keyword}
                              name="keyword"
                              placeholder="Search reviews"
                              onChange={this.onSearch}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Type</label>
                          <div className="col-sm-9">
                            <Select
                              name="ratingForData"
                              value={this.state.ratingForData}
                              onChange={this.handleRatingForChange}
                              options={this.state.ratingForList}
                              isMulti={false}
                              isSearchable={true}
                              isClearable
                              onClear={this.handleClearRatingFor}
                              placeholder="Select Type"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Review Type</label>
                          <div className="col-sm-9">
                            <Select
                              name="reviewTypeData"
                              value={this.state.reviewTypeData}
                              onChange={this.handleReviewTypeChange}
                              options={this.state.reviewTypeList}
                              isMulti={false}
                              isSearchable={true}
                              isClearable
                              onClear={this.handleClearReviewType}
                              placeholder="Select Review Type"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Rating</label>
                          <div className="col-sm-9">
                            <Select
                              name="ratingData"
                              value={this.state.ratingData}
                              onChange={this.handleRatingChange}
                              options={this.state.ratingList}
                              isMulti={false}
                              isSearchable={true}
                              isClearable
                              onClear={this.handleClearRating}
                              placeholder="Select Rating"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Status</label>
                          <div className="col-sm-9">
                            <Select
                              name="isPublishedData"
                              value={this.state.isPublishedData}
                              onChange={this.handleIsPublishedChange}
                              options={this.state.isPublishedList}
                              isMulti={false}
                              isSearchable={true}
                              isClearable
                              onClear={this.handleClearIsPublished}
                              placeholder="Select Publish Status"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <div className="text-left col">
                            <Button
                              onClick={this.handleSearch}
                              disabled={this.state.isSearching}
                            >
                              {this.state.isSearching ? 'Searching...' : 'Search'}
                            </Button>
                            <Button
                              variant={'outlined'}
                              onClick={this.handleClearAll}
                            >
                              Clear
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body"></div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Review List'}
                          className="table-responsive"
                          data={this.state.review_data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ReviewList
